import React from "react";
import "./ScrollableContent.scss";

const ScrollableContent = (props) => {
  return (
    <div
      className="scrollable-content"
      style={props.style}
      onClick={props.onClick}
    >
      {props.children}
    </div>
  );
};

export default ScrollableContent;
